import '@pmh/shared/styles.css';
import { registerServiceWorker, StagingBadge } from '@pmh/shared';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import './guest.css';
import { SessionProvider } from './lib/session';
import { router } from './router';

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, staleTime: 30_000, refetchOnWindowFocus: false } },
});

const root = document.getElementById('root');
if (!root) throw new Error('missing #root');
createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <SessionProvider>
        <RouterProvider router={router} />
        <StagingBadge />
      </SessionProvider>
    </QueryClientProvider>
  </StrictMode>,
);

registerServiceWorker();
